import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTASection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-88">
      <div className="max-w-5xl mx-auto" data-id="element-89">
        <div className="bg-gradient-to-br from-green-600 to-blue-600 rounded-3xl p-8 md:p-16 text-white text-center shadow-2xl" data-id="element-90">
          <h2 className="text-3xl md:text-5xl font-black mb-6" data-id="element-91">
            Entrá hoy a Dominando Shopify
          </h2>

          <p className="text-xl md:text-2xl mb-8 leading-relaxed max-w-3xl mx-auto" data-id="element-92">
            Creá una fuente de ingresos por internet con Shopify, IA y una
            estructura clara para acercarte a una vida con más tiempo y
            libertad.
          </p>

          <div className="bg-white text-gray-900 rounded-2xl p-8 inline-block mb-8" data-id="element-93">
            <p className="text-6xl md:text-7xl font-black text-green-600 mb-4" data-id="element-94">
              ARS 34.990
            </p>
            <div className="space-y-2 text-lg font-semibold" data-id="element-95">
              <p data-id="element-96">✓ 4 mentorías en vivo + bonos incluidos</p>
              <p data-id="element-97">✓ Garantía de 7 días</p>
            </div>
          </div>

          <CTAButton text="QUIERO EMPEZAR AHORA" onClick={scrollToCompra} size="large" className="bg-white hover:bg-gray-100 !text-green-700 font-black text-2xl px-16 py-8 w-full md:w-auto animate-pulse-green" data-id="element-98" />
        </div>
      </div>
    </section>;
}